import { Dispatch } from 'react-redux';
import { AccountingState } from './accounting.reducer';
import { requestAction, doAsync } from '@common/components/common.actions';
import { contractService } from '@services/ContractService';
import { Action } from 'redux';
import { CancelledContractModel } from '@models/ContractCancellation';
import { PageViewModel } from '@models/common.models';

export enum AccountingActionType {
  SetAccountingOwnership = 'SetAccountingOwnership',
  SetCancelledContractsList = 'SetCancelledContractsList',
  SetQueryAndDisbursed = 'SetQueryAndDisbursed'
}

interface AccountingAction extends Action {
  readonly type: AccountingActionType;
}

/***** Set Accounting Ownership *****/
export interface SetAccountingOwnershipAction extends AccountingAction {
  readonly cancelledContract: CancelledContractModel;
}
export function changeAccountingOwnership(contractId: number, release?: boolean) {
  return async (dispatch: Dispatch<AccountingState>): Promise<SetAccountingOwnershipAction | undefined> => {
    return dispatch(
      requestAction(() => contractService.changeAccountingOwnership(contractId, release), setAccountingOwnership)
    );
  };
}
export function setAccountingOwnership(cancelledContract: CancelledContractModel): SetAccountingOwnershipAction {
  return {
    type: AccountingActionType.SetAccountingOwnership,
    cancelledContract: cancelledContract
  };
}

/***** Search Cancelled Contracts List *****/
export interface SetQueryAndDisbursedAction extends AccountingAction {
  readonly query: string | null;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly orderBy: string;
  readonly filterByDisbursed: boolean;
}
export interface SetCancelledContractsListAction extends AccountingAction {
  readonly results: PageViewModel<CancelledContractModel>;
}
export function searchCancelledContractsList(
  query: string | null,
  pageSize: number,
  pageNumber: number,
  orderBy: string,
  orderDirection: string,
  filterByDisbursed: boolean
) {
  return async (dispatch: Dispatch<AccountingState>) => {
    return dispatch(doAsync(setQueryAndDisbursed(query, pageNumber, pageSize, orderBy, filterByDisbursed)))
      .then(() => {
        return dispatch(
          requestAction(
            () =>
              contractService.searchCancelledContractsList(
                query,
                pageSize,
                pageNumber,
                orderBy,
                orderDirection,
                filterByDisbursed
              ),
            setCancelledContractsList
          )
        );
      })
      .catch(e => {
        throw e;
      });
  };
}

export function setQueryAndDisbursed(
  query: string | null,
  pageNumber: number,
  pageSize: number,
  orderBy: string,
  filterByDisbursed: boolean
): SetQueryAndDisbursedAction {
  return {
    type: AccountingActionType.SetQueryAndDisbursed,
    query: query,
    pageNumber: pageNumber,
    pageSize: pageSize,
    orderBy: orderBy,
    filterByDisbursed: filterByDisbursed
  };
}

export function setCancelledContractsList(
  results: PageViewModel<CancelledContractModel>
): SetCancelledContractsListAction {
  return {
    type: AccountingActionType.SetCancelledContractsList,
    results: results
  };
}



// WEBPACK FOOTER //
// ./src/accounting/accounting.actions.tsx